import React, { Component } from "react";
import { connect } from "react-redux";
import { dashboardActions } from "../../../_actions";
import * as XLSX from "xlsx";
import moment from 'moment';

import LayoutWrap from "../Component/LayoutWrap";
import { ActivitiesStatus } from './Component/ActivitiesStatus';
import { EmailsContent } from './Component/EmailsContent';
import { ActivityLogsContent } from './Component/ActivityLogsContent';

import { LuArrowLeft } from 'react-icons/lu';

class AssignTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrAssignedId: this.props.match.params.id,
      activeTab: 'Activities Status',
      employees: [],
      showAssignModal: false,
      showUpdateModal: false,
      step: 1,
      assignFormData: {
        surveyId: "",
        caseStudyId: "",
        rolePlayId: "",
        mailIdList: [],
        employeeId: ""
      },
      approvalFormData: {}
    };
  }

  componentDidMount() {

    const dataX = {
      assignedId: this.state.crrAssignedId
    }

    this.props.dispatch(dashboardActions.getInsightEmpTaskById(dataX));
    this.props.dispatch(dashboardActions.getInsightActivityStatus(dataX));

  }


  handleTabClick = (tabName) => {
    this.setState({ activeTab: tabName }, () => {
      if (tabName === 'Activity Logs') {

        const dataX = {
          assignedId: this.state.crrAssignedId
        }
        this.props.dispatch(dashboardActions.getInsightActivityTrackingByEmpId(dataX));

      }
    });
  };

  openPrintModal = () => {
    this.setState({ showPrintModal: true });
  }

  closeModal = () => {
    this.setState({ showPrintModal: false });
  }

  handleApprovalChange = (sno, value) => {
    let { approvalFormData } = this.state;
    approvalFormData[sno] = value;
    this.setState({ approvalFormData }, () => {

      const dataX = {
        assignedId: this.state.crrAssignedId,
        activity: sno.toString(),
        status: value
      }

      const tempX = {
        assignedId: this.state.crrAssignedId
      }
      this.props.dispatch(dashboardActions.saveInsightActivityApproval(dataX, tempX));

    });
  }


  renderContent = (logList, statusData, activityStatus) => {

    const logData = logList && logList.length > 0 ? logList.map((ele, i) => ({
      id: i + 1,
      action: ele.activity,
      date: ele.createdAt ? moment(ele.createdAt).utcOffset("+05:30").format("DD MMMM YYYY") : "-",
      time: ele.createdAt ? moment(ele.createdAt).utcOffset("+05:30").format("hh:mm A") : "-"
    })) : {}

    let userDetails = {
      "initial": statusData?.employeeId?.name.charAt(0),
      "name": statusData?.employeeId?.name,
      "email": statusData?.employeeId?.email
    }

    switch (this.state.activeTab) {
      case 'Activities Status': return <ActivitiesStatus
        userDetails={userDetails}
        activityStatus={activityStatus}
        statusData={statusData}
        approvalFormData={this.state.approvalFormData}
        handleApprovalChange={this.handleApprovalChange}
      />;
      case 'Emails Status': return <EmailsContent userDetails={userDetails} statusData={statusData} />;
      case 'Activity Logs': return <ActivityLogsContent userDetails={userDetails} logData={logData} />;
      default: return <ActivitiesStatus userDetails={userDetails} />;
    }
  }

  /* FILE UPLOAD */
  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const formattedData = jsonData.map((row, index) => ({
        sno: index + 1,
        emp_id: row.emp_id || "",
        name: row.name || "",
        email: row.email || "",
        mobile: row.mobile || "",
        assigned: "No"
      }));

      this.setState((prev) => ({
        employees: [...prev.employees, ...formattedData]
      }));
    };

    reader.readAsBinaryString(file);
  };

  /* MODAL */
  toggleAssignModal = () => {
    this.setState((prev) => ({
      showAssignModal: !prev.showAssignModal,
      step: 1
    }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState((prev) => ({
      assignFormData: {
        ...prev.assignFormData,
        [name]: value
      }
    }));
  };

  nextStep = () => this.setState((prev) => ({ step: prev.step + 1 }));
  prevStep = () => this.setState((prev) => ({ step: prev.step - 1 }));

  /* MAIL SELECT */
  handleMailSelect = (id) => {
    this.setState((prev) => {
      const exists = prev.assignFormData.mailIdList.includes(id);

      return {
        assignFormData: {
          ...prev.assignFormData,
          mailIdList: exists
            ? prev.assignFormData.mailIdList.filter((m) => m !== id)
            : [...prev.assignFormData.mailIdList, id]
        }
      };
    });
  };

  /* EMPLOYEE SELECT */
  handleEmpSelect = (employeeId) => {
    this.setState((prev) => {
      const isSame = prev.assignFormData.employeeId === employeeId;

      return {
        assignFormData: {
          ...prev.assignFormData,
          employeeId: isSame ? null : employeeId
        }
      };
    });
  };

  /* FINAL SUBMIT */
  handleFinalAssign = () => {
    const { assignFormData } = this.state;
    console.log("FINAL:", assignFormData);

    const temp = {
      keyWord: "",
      pageNo: 1,
      size: 10
    };
    this.props.dispatch(dashboardActions.assignInsightEmpTasks(assignFormData, temp));

    this.toggleAssignModal();
  };

  onCloseAssignModal = () => {
    this.setState({ showAssignModal: false })
  }

  onEdit = (value) => {
    this.setState({ showUpdateModal: true, updateFormData: value.data })
  }

  handleSendReply = (mailId, replyText) => {
    const payload = {
      mailLibId: mailId,
      subject: "Re: Mail Response",
      body: `<p>${replyText}</p>`,
      // add other fields if your API needs
    };

    console.log("Reply Payload:", payload);

    // TODO: Replace with actual API
    // this.props.dispatch(dashboardActions.sendMailReply(payload));

  };

  goToBack = () => {
    this.props.history.push("/insightadmin/assign");
  }

  render() {
    const { step, assignFormData, showPrintModal } = this.state;
    const { dashboard } = this.props;

    const tabs = ['Activities Status', 'Activity Logs'];
    // const tabs = ['Activity Logs'];

    const {
      getInsightEmpTaskByIdData = [],
      getInsightActivityTrackingByEmpIdData = [],
      getInsightActivityStatusData = {}
    } = dashboard;


    console.log("getInsightActivityStatusData------------------------>", getInsightActivityStatusData)


    return (
      <>
        <LayoutWrap>
          <div className="flex flex-col h-screen bg-white textblack">

            {/* Header */}
            <div className="flex items-center gap-4 p-4 border-b border-gray-300 shrink-0">
              <button onClick={this.goToBack} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
                <LuArrowLeft size={24} />
              </button>
              <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
                Status Panel
              </h1>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-300 shrink-0">
              <nav className="flex md:px-8 px-4 md:space-x-10 space-x-6">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => this.handleTabClick(tab)}
                    className={`py-4 px-1 border-b md:text-base text-sm font-medium ${this.state.activeTab === tab
                      ? "border-indigo-600 text-indigo-600"
                      : "border-transparent hover:text-indigo-600"
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </nav>
            </div>

            {/* 🔥 Content Area (IMPORTANT) */}
            <div className="flex-1 overflow-hidden overflow-y-auto h-full">
              {this.renderContent(getInsightActivityTrackingByEmpIdData, getInsightEmpTaskByIdData, getInsightActivityStatusData)}
            </div>

          </div>

        </LayoutWrap>
      </>
    );
  }
}

export default connect((state) => ({ dashboard: state.dashboard }))(
  AssignTask
);